export interface IDropdownSettings {
  apliCall?: boolean;
  freeText?: boolean;
  free_text_with_data?:boolean;
  configFreeText?: boolean;
  markFreeText?: boolean;
  spclChrFreeTextAllowed?: boolean;
  singleSelection?: boolean;
  idField?: string;
  textField?: string;
  disabledField?: string;
  speechToText:boolean;
  enableCheckAll?: boolean;
  selectAllText?: string;
  unSelectAllText?: string;
  allowSearchFilter?: boolean;
  clearSearchFilter?: boolean;
  maxHeight?: number;
  itemsShowLimit?: number;
  limitSelection?: number;
  searchPlaceholderText?: string;
  spclChrPattern?: string;
  noDataAvailablePlaceholderText?: string;
  closeDropDownOnSelection?: boolean;
  showSelectedItemsAtTop?: boolean;
  defaultOpen?: boolean;
  checkBoxRequired?: boolean;
  itemCode?: string;
  displayName?: string;
  advancesearch?: any;
  barcode:boolean;
  flag:boolean;
  hasAppliedCss:boolean;
  location_icon:any;
  createComponent:boolean;
  createComponentDatasource:any;
  preserveTemplate?:any;
  defaultData?: true;
  onEnterSearch?: false;
  stopInitialization?:false;
  isMinHeight: true;
  hit_search:boolean;
  textSearch:boolean;
  custom: boolean;
  coding_system?: string;
  filter:any;
}
export class ListItem {
  id: String | number;
  text: String | number;
  formatText: String | number;
  isDisabled?: boolean;
  itemCode?: string = "";
  displayName?: string = "";
  mixdata: any;
  coding_system?: string = "";
  isNonFormulary?: boolean = false
  
  public constructor(source: any) {
    if (typeof source === 'string' || typeof source === 'number') {
      this.id = this.text = source;
      this.isDisabled = false;
    }
    if (typeof source === 'object') {
      this.id = source.id ? source.id : "";
      this.text = source.text ? source.text : source.text;
      this.isDisabled = source.isDisabled ? source.isDisabled : "";
      this.displayName = source.displayName ? source.displayName : "";
      this.mixdata = source.mixdata ? source.mixdata : "";
      this.itemCode = source.itemCode ? source.itemCode : "";
      this.coding_system = source.coding_system ? source.coding_system:'';
      this.isNonFormulary = (source.mixdata ?? source)?.isFormulary === 'Non Formulary';
    }
  }
}
